var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('page-video-cell');
import { breakpoints } from '@shapeable/theme';
import { EntityCell } from './entity-cell';
import { VideoImage } from './video-image';
import { useModal } from '../../hooks/use-modal';
import { VideoPlayer } from '../elements/video-player';
import { first } from 'lodash';
export var PageVideoCellDefaultProps = {
  modalColor: '#000000'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});

var size = function size(width) {
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n  "])), width, 9 / 16 * width);
};

var VideoStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: #000;\n  box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "], ["\n  background: #000;\n  box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "])), size(320)),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(400)),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(640)),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), size(980))
}); // -------- Components -------->

var My = {
  Container: styled(EntityCell)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(VideoImage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Video: styled(VideoPlayer)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), VideoStyles)
};
export var PageVideoCell = function PageVideoCell(props) {
  var className = props.className,
      entity = props.entity,
      modalColor = props.modalColor,
      color = props.color,
      opacity = props.opacity;
  var modal = useModal();
  var video = first(entity.videos);

  var onClick = function onClick() {
    modal.show(React.createElement(My.Video, {
      playing: true,
      url: video.url
    }), modalColor);
  };

  return React.createElement(My.Container, {
    onClick: onClick,
    entity: entity,
    className: cls.name(className),
    image: React.createElement(My.Image, {
      color: color,
      opacity: opacity,
      entity: video
    })
  });
};
PageVideoCell.defaultProps = PageVideoCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;